import React, {Component} from 'react';
import {Col, Grid} from 'react-bootstrap';
import map from 'lodash/map';
import {isMac} from '../isMac';

const SHORTCUTS_MAP = [
    {
        area: 'Global',
        shortcuts: [
            {keys: ['?'], description: 'Show shortcuts help'},
        ],
        col: 12,
    },
    {
        area: 'Editor',
        col: 12,
        shortcuts: [
            {keys: ['esc'], description: 'Go to my images'},
            {keys: ['space'], description: 'Toggle between original and popped images'},
            {keys: <span><kbd>{'1'}</kbd>{','}<kbd>{'2'}</kbd>{',...'}</span>, description: 'Switch to preset'},
            {keys: ['c'], description: 'Show the contrast image'},
            {keys: ['mod-s'], description: 'Save current image as png'},
            {keys: ['mod-p'], description: 'Print current image'},
            {keys: ['mod-o'], description: 'Upload a new image'},
            {keys: ['→'], description: 'Go to the next image'},
            {keys: ['←'], description: 'Go to the previous image'},
            {keys: ['↑'], description: 'Go to the previous selected image'},
            {keys: ['↓'], description: 'Go to the next selected image'},
            {keys: ['s'], description: 'Add image to current selection'},
            {keys: ['p'], description: 'Set the current preset as the preferred preset for the image'},
            {keys: ['mod-alt-p'], description: 'Set the current preset as the preferred preset for all the selected images'},
            {keys: ['mod-delete'], description: 'Delete the current image'},
            {keys: ['Z'], description: 'Select the zoom-in mode'},
            {keys: ['z'], description: 'Select the zoom-out mode'},
            {keys: ['h'], description: 'Select the pan mode'},
            {keys: ['`'], description: 'Recenter the image in the canvas'},
            {keys: ['.'], description: 'Turn off any zoom/pan or brush/lasso modes'},
            {keys: ['b', 'B'], description: 'Select/Cycle the brush size'},
            {keys: ['l', 'L'], description: 'Select/Cycle the lasso tool'},
            {keys: ['mod-z'], description: 'Undo last edit'},
            {keys: ['mod-y'], description: 'Redo last edit'},
            {keys: ['e'], description: 'Select full erase mode'},
            {keys: ['d'], description: 'Select decrease effect mode'},
            {keys: ['i'], description: 'Select increase effect mode'},
        ]
    },
];


export default class Shortcuts extends Component {

    render() {
        return (
            <Grid fluid={true}>{
                map(SHORTCUTS_MAP, ({area, shortcuts, col}) => {
                    return (
                        <Col md={col} key={area}>
                            <table className="keyboard-mappings">
                                <tbody>
                                <tr>
                                    <th/>
                                    <th>{area}</th>
                                </tr>
                                {
                                    map(shortcuts, (shortcut, idx) => {
                                        let keysControls;
                                        if (Array.isArray(shortcut.keys)) {
                                            keysControls = map(shortcut.keys, (key, j) => {
                                                return (
                                                    [<kbd key={j}>{key.replace('mod', isMac ? 'cmd' : 'ctrl')}</kbd>, j + 1 < shortcut.keys.length ? ' or ' : '']
                                                );
                                            });
                                        } else {
                                            keysControls = shortcut.keys;
                                        }
                                        return (
                                            <tr key={idx}>
                                                <td className="keys">{keysControls}</td>
                                                <td>{shortcut.description}</td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                        </Col>
                    );
                })
            }</Grid>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Shortcuts.js